let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iWT4e")).then(() => parcelRequire('eEQFA'));